import moment from 'moment';

class DashboardController {
  constructor(AuthenticationService, CompanyService, DashboardService, $rootScope, $state, $http) {
    "ngInject";
    this.authenticationService = AuthenticationService;
    this.companyService = CompanyService;
    this.dashboardService = DashboardService;
    this.name = 'dashboard';
    this.company = undefined;
    this.dashboard = {};
    this.moment = moment;
    this.$rootScope = $rootScope;
    this.companyTagline = 'The Special Forces of Software Engineering';
    this.$state = $state;
    this.auth = this.authenticationService;
    this.company = {};
    let self = this;
    self.pageLoad = false;


    $http.get($rootScope.apiHost +'/api/admin/dashboard/customercount', {withCredentials: true}).then(function (response) {
      self.customerCount = response.data;
      self.pageLoad = true;
    });

    $http.get($rootScope.apiHost +'/api/admin/dashboard/contractcount', {withCredentials: true}).then(function (response) {
      self.contractCount = response.data;
      self.pageLoad = true;
    });

    $http.get($rootScope.apiHost +'/api/admin/dashboard/projectcount', {withCredentials: true}).then(function (response) {
      self.projectCount = response.data;
      self.pageLoad = true;
    });

    $http.get($rootScope.apiHost +'/api/admin/dashboard/employeecount', {withCredentials: true}).then(function (response) {
      self.employeeCount = response.data;
      self.pageLoad = true;
    });


    this.companyService.getCompany().then(function (response) {
      self.company = response.data;
    });

    self.revenueChartData = [];


    this.dashboardService.getDashboardInformation().then(function (response) {
      self.dashboard = response.data;
      self.loadFiveYearLookBack(self.dashboard.monthlyRevenueNumbers);
      self.dashboardInfoLoaded = true;
    });


    this.chartUsersOptions = {
      series: {
        splines: {
          show: true,
          tension: 0.4,
          lineWidth: 1,
          fill: 0.4
        },
      },
      grid: {
        tickColor: "#f0f0f0",
        borderWidth: 1,
        borderColor: 'f0f0f0',
        color: '#6a6c6f'
      },
      colors: [ "#62cb31", "#efefef"],
    };


    this.revenueChartOptions = {
      series: {
        lines: {
          show: true,
          lineWidth: 1
        }
      },
      yaxis: {
        tickLength: 5,
        show: true,
        tickFormatter: function numberWithCommas(x) {
          return x.toString().replace(/\B(?=(?:\d{3})+(?!\d))/g, ",");
        }
      },
      xaxis: {
        mode: 'time',
        tickSize: [1, 'month'],
        // tickLength: 1,
        ticks: [[1, "Jan"], [2, "Feb"], [3, "Mar"], [4, "Apr"], [5, "May"], [6, "Jun"], [7, "Jul"], [8, "Aug"], [9, "Sep"], [10, "Oct"], [11, "Nov"], [12, "Dec"]]
      },
      colors: ["#3498db"],
      grid: {
        show: true,
        hoverable: true,
        clickable: true,
        borderWidth: 0,
        labelMargin: 0,
        axisMargin: 0,
        minBorderMargin: 0,
      },
      valueLabels: {
        show: true
      }
    };


    this.xx = 1;
  }

  getLogoUrl() {
    if(this.company && this.company.id) {
      return this.$rootScope.apiHost + "/api/admin/companies/" + this.company.id + "/logo";
    }
  }


  checkPermission(e, permission) {
    if(!this.auth.hasPermission(permission)){
      e.preventDefault();
    }
  }


  plotClick(event, pos, item) {
    if(item) {
      let month = item.datapoint[0];
      let value = item.datapoint[1];

      console.log(month);
      console.log(value);

      let revenue = this.currency(value);

      let nobreak = true;
      let i = 1;
      while (i < 13) {
        if(month > ((i-1) +0.3) && month < (i + 0.3)) {
          month = i;
          nobreak = false;
        }

        i++;
      }

      let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      this.selectedPoint = months[month -1] + " " + item.series.label + ": " + revenue;
    }
  }

  viewTimesheets(status){
    // TODO: Add filter to route and apply on page load
    this.$state.go('review')
  }

  addChartData(year, value) {

    let data = [];

    let i = 1;
    value.forEach(function (record) {
      let x = [i,record.revenue];
      data.push(x);
      i++;
    });

    this.xx = this.xx + 1;
    this.revenueChartData.push(x);
  }

  loadFiveYearLookBack(data) {

   let q = ['#9b59b6', '#3498db','#62cb31','#ffb606','#e67e22'];

    let self = this;
    let p = 0;
    Object.keys(data).forEach(function (key) {
      let x = {
        label: key,
        data: data[key],
        color: q[p]
      };

      if(p > 1) {
        self.revenueChartData.push(x);
      }

      p++;

    });
  }

  currency(value) {
    let formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    });

    return isNaN(value) ? null : formatter.format(value);
  }

  number(value) {
    let formatter = new Intl.NumberFormat('en-US', {
      style: 'decimal'
    });

    return formatter.format(value);
  }

}

export default DashboardController;



// WEBPACK FOOTER //
// ./client/pages/admin/dashboard/dashboard.controller.js